module.exports = __webpack_public_path__ + "img/tmall1.7ad91e99.png";